import { EventEmitter, Output } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, RowNode, SelectionChangedEvent } from 'ag-grid-community';
import * as fileSaver from 'file-saver';
import { BObjectModel, FileModel, InsertDocOption, QResult, Select, TDOLien } from '../../../../../models';
import { ModeEffectif, Option } from '../../../../../models/effectif/option.model';
import { StageDocumentUpdate } from '../../../../../models/formation/formation.model';
import { CoreService, HttpService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { StageService } from '../../services/stage-modal.service';
import { DocumentService } from '../document.service';

@Component({
  selector: 'queoval-stage-list-documents',
  templateUrl: './list-documents.component.html',
  styleUrls: ['./list-documents.component.css']
})
export class ListDocumentsComponent implements OnInit {

  public idStage: string = '';
  public refreshData: boolean;
  public selectedNodes: RowNode[];
  public lstSelectedDoc: Select[];
  public selectedRowsDoc: any[];
  public isUploadingInProgress: boolean;
  public nivseDOCSelected: string;
  public insertDocModel: BObjectModel;
  /**
   * Nombre de documetns sélectionnés
   */
  public nbDocSelected: number;
  public effectifs: Array<InsertDocOption>;

  @Input('refreshGrid') set SetRefreshGrid(value: boolean) {
    if (value) {
      this.refreshData = value;
      setTimeout(() => { this.refreshGridChange.emit(false); }, 250);
    }
    
  }
  @Output() refreshGridChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  //#region Constructeur
  constructor(
    public service: StageService,
    public docService: DocumentService,
    private http: HttpService,
    private indparam: CoreService,
    private toast: ToastService,
    private modalService: NgbModal,
  ) { }
  //#endregion Constructeur

  //#region Cycle de vie
  ngOnInit(): void {
    this.idStage = this.service.Stage.Ident;
    this.isUploadingInProgress = false;
    this.insertDocModel = new BObjectModel();
    this.nbDocSelected = 0;
    this.selectedRowsDoc = [];
    this.insertDocModel.Mode = 'CREATE';
    this.insertDocModel.Action = 'ANG_INSERT_DOC';
    this.insertDocModel.IdDonneeFils = '0';
    this.insertDocModel.IdDonneePere = this.service.Stage.Ident;
    this.insertDocModel.IdentBO = "BO_DOCUMENT";
    this.insertDocModel.CodeRelation = 'REL_BO_STAGE_BO_DOCUMENT';
    this.effectifs = [
      new InsertDocOption(new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.CLIENTMAIL, "InsertDoc"), TDOLien.Cols.intIdPere, 'REL_BO_CSOC_BO_DOCUMENT' ),
      new InsertDocOption(new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.STAGIAIREMAIL, "InsertDoc"), TDOLien.Cols.intIdPere, 'REL_BO_CONTACT_BO_DOCUMENT'),
      new InsertDocOption(new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.FORMATEURMAIL, "InsertDoc"), TDOLien.Cols.intIdPere, 'REL_BO_FORMATEUR_BO_DOCUMENT')
    ];
  }
  /**
   * Génération des factures -> 2 actions : téléchargement unitaire ou telechargement d'un zip + modification de l'état
   */
  public genereDocuments(): void {
    this.indparam.showSplash(true);

    if (this.lstSelectedDoc.length == 1) {
      // Téléchargement unitaire de chaque facture
      this.lstSelectedDoc.forEach((doc: Select) => {
        const modelDownload: FileModel = new FileModel();
        modelDownload.DownloadMode = 'PDFFROMIDENT';
        modelDownload.Ident = doc.id;
        modelDownload.Name = doc.id;
        modelDownload.Extension = 'pdf';
        this.http.download(`${this.indparam.AppParams.apiUrl}api/Download`, modelDownload).subscribe((response: any) => {
          const fileType: string = 'application/pdf';
          const blob: Blob = new Blob([(response)], {
            type: fileType,
          });
          if (blob.size > 0) {
            fileSaver.saveAs(blob, `${doc.value}.pdf`);
          }
        });
      });
    }
    else {
      // Generation d'un zip contenant toutes les factures sélectionnées
      const modelDownload: FileModel = new FileModel();
      modelDownload.DownloadMode = 'ZIPFILEFROMLISTIDENT';
      modelDownload.Ident = '';
      modelDownload.Name = '';
      modelDownload.Extension = 'zip';
      modelDownload.LstIdent = new Array<string>();
      this.lstSelectedDoc.forEach((doc: Select) => {
        modelDownload.LstIdent.push(doc.id);
      });
      this.isUploadingInProgress = true;
      this.http.download(`${this.indparam.AppParams.apiUrl}api/Download`, modelDownload).subscribe((response: any) => {
        const fileType: string = 'application/zip';
        const blob: Blob = new Blob([(response)], {
          type: fileType,
        });
        if (blob.size > 0) {
          fileSaver.saveAs(blob, `Documents_${new Date(Date.now()).toLocaleDateString()}.zip`);
        }
        this.isUploadingInProgress = false;
      });
    }

    this.indparam.showSplash(false);
  }
  /* 
   * Permet de recharger la grid
   */
  public refreshGrid(): void {
    this.refreshGridChange.emit(true);
  }

  /*
 * Permet d'avoir les lignes selectionnées
 */
  public selectLine(event: SelectionChangedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
    this.addSelectedDoc(event.api);
  }

  /**
   * permet d'ajouter les infos du documents dans la liste
   * pour la génération (unitaire ou .zip)
   * @param event document selectionné dans la grid
   */
  public addSelectedDoc(event: GridApi): void {
    //// Récupération des lignes sélectionnées
    this.selectedRowsDoc = []; //gridApi.getSelectedRows();
    event.forEachNodeAfterFilterAndSort((rowNode: any) => {
      if (rowNode.selected) {
        this.selectedRowsDoc.push(rowNode.data);
      }
    });

    this.nbDocSelected = this.selectedRowsDoc.length;

    if (this.nbDocSelected !== 0) {
      // Création du modèle contenant la liste des factures
      this.lstSelectedDoc = new Array<Select>();

      // Ajout des factures "cochées"
      this.selectedRowsDoc.forEach((row: any) => {

        // Contruction de l'objet à ajouter à la liste des factures
        const doc: Select = new Select();
        doc.id = row['Ident'];
        doc.value = row['TitreDOC'];
        this.lstSelectedDoc.push(doc);
      });
    }
    // si aucun élément n'est sélectionné
    else {
      this.selectedRowsDoc = [];
      this.lstSelectedDoc = [];
      this.nbDocSelected = 0;
    }
  }



  /*
   * Modifier le niveau d'accessibilité d'un ou plusieurs document(s) sur l'extranet
   */
  public updateNivseDOC() {
    // Création du model (liste des ident de documents à modifier et valeur du niveau extranet selectionné)
    let documentUpdateNivseDOC = new StageDocumentUpdate();
    documentUpdateNivseDOC.DocumentIdentList = new Array<string>();
    documentUpdateNivseDOC.StringData = this.nivseDOCSelected;
    this.selectedNodes.forEach((document) => {
      documentUpdateNivseDOC.DocumentIdentList.push(document.data.Ident)
    });

    // Modifications des documents côté serveur
    this.http.postHttp<QResult<StageDocumentUpdate>>(`${this.indparam.AppParams.apiUrl}api/Stage/Document/UPDATE_nivseDOC`, documentUpdateNivseDOC).subscribe(
      (result: QResult<StageDocumentUpdate>) => {
        if (!result.HasError) {
          this.toast.showSuccessToast("Document(s) modifié(s)");
          this.refreshGrid();
        }
        this.indparam.showSplash(false);
      });
  }

  /*
   * Supprimer les documents selectionnés
   */
  public deleteSelection() {
    let documentModel = new StageDocumentUpdate();
    documentModel.DocumentIdentList = new Array<string>();
    this.selectedNodes.forEach((document) => {
      documentModel.DocumentIdentList.push(document.data.Ident)
    });
    documentModel.StringData = this.service.Stage.Ident;

    this.http.postHttp<QResult<StageDocumentUpdate>>(`${this.indparam.AppParams.apiUrl}api/Stage/Document/DELETE_DOC`, documentModel).subscribe(
      (result: QResult<StageDocumentUpdate>) => {
        if (!result.HasError) {
          //gestion d'alert cote back
          //if (!result.HasAlert) {
          //  this.toast.showSuccessToast("Document(s) supprimé(s)");
          //}
          this.refreshGrid();
        }
        this.indparam.showSplash(false);
      });
  }

/** Ouvrir une modal , la taille dépend du paramètre xl (vrai par default => modal taille q-xxl)
 * 
 * @param Modal la modal qui doit être ouverte
 * @param xl si oui la modal est grande, sinon elle est de taille réduite
 */
  public open(Modal: any, xl: boolean = true) {
    if (xl) {
      this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' });
    } else {
      this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
    }
  }
  //#endregion Fonctions Publics
}
